import {
  LOGIN_USER,
  LOGGING_IN_USER,
  LOGOUT_USER,
  SET_ERROR_MESSAGE,
  GET_BOOK_INFO,
  GETTING_BOOK_INFO,
  GET_CHAPTER_INFO,
  GETTING_CHAPTER_INFO,
  GET_TOPIC_INFO,
  GETTING_TOPIC_INFO,
  GET_CLASS_INFO,
  GETTING_CLASS_INFO,
  GET_ELP_CHAPTER_INFO,
  GETTING_ELP_CHAPTER_INFO,
} from "./actions";

let initialState = {
  error: '',
  isLogging: false,
  user: {},
  isAuthenticated: false,
  class: {},
  isGettingClass: false,
  book: {},
  isGettingBook: false,
  chapter: {},
  isGettingChapter: false,
  elp_chapter: {},
  isGettingElpChapter: false,
  topic: {},
  isGettingTopic: false
}

function dataReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ERROR_MESSAGE:
      return { ...state, error: action.error };
    case LOGIN_USER:
      return { ...initialState, user: action.userData, isAuthenticated: action.isAuthenticated };
    case LOGGING_IN_USER:
      return { ...state, isLogging: action.status }
    case LOGOUT_USER:
      return { ...initialState };
    case GET_BOOK_INFO:
      return { ...state, book: action.book }
    case GETTING_BOOK_INFO:
      return { ...state, isGettingBook: action.status }
    case GET_CHAPTER_INFO:
      return { ...state, chapter: action.chapter }
    case GETTING_CHAPTER_INFO:
      return { ...state, isGettingChapter: action.status }
    case GET_TOPIC_INFO:
      return { ...state, topic: action.topic }
    case GETTING_TOPIC_INFO:
      return { ...state, isGettingTopic: action.status }
    case GET_CLASS_INFO:
      return { ...state, class: action.class }
    case GETTING_CLASS_INFO:
      return { ...state, isGettingClass: action.status }
    case GET_ELP_CHAPTER_INFO:
      return { ...state, elp_chapter: action.chapter }
    case GETTING_ELP_CHAPTER_INFO:
      return { ...state, isGettingElpChapter: action.status }
    default:
      return state;
  }
}

export default dataReducer;

export const getUserData = state => state.user;
export const getLoggingStatus = state => state.isLogging;
export const getisAuthenticated = state => state.isAuthenticated;
export const getUserRole = state => state.user.role;
export const getErrorMessage = state => state.error;
export const getBookInfo = state => state.book;
export const gettingBookInfo = state => state.isGettingBook;
export const getClassInfo = state => state.class;
export const gettingClassInfo = state => state.isGettingClass;
export const getChapterInfo = state => state.chapter;
export const getElpChapterInfo = state => state.elp_chapter;
export const getTopicInfo = state => state.topic;